import { render } from "./account.svg?vue&type=template&id=61d4c4a0"
const script = {}

import exportComponent from "/Users/machintoshssd/sites/bio-effect-dk-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__